import { Flex, Spinner, Text } from "@chakra-ui/react";

export default function LoadingState() {
  return (
    <Flex alignItems="center" gap={2} py={2}>
      <Spinner size="sm" />
      <Text>Loading certification broadcast settings...</Text>
    </Flex>
  );
}
